<template>
  <rest-form-page
    :page-title="pageTitle"
    :fetch-endpoint="fetchEndpoint"
    :save-endpoint="saveEndpoint"
    :after-save="afterSave"
    :model="model"
    :readonly="readonly"
    data-qa="loyalty-settings-form"
    @on-error="handleError"
  >
    <template slot="form" v-if="model">
      <form-section data-qa="loyalty-settings-form-section">
        <rest-form-item
          prop="loyalty"
          :label="$t('LoyaltySettings_Loyalty')"
          data-qa="loyalty-settings-form-item"
        >
          <feature-toggle
            v-model="model.loyalty"
            data-qa="loyalty-settings-form-item-toggle"
          />
        </rest-form-item>
      </form-section>
    </template>
  </rest-form-page>
</template>

<script>
import RestFormPage from '@/common/components/rest/RestFormPage'
import RestFormItem from '@/common/components/rest/RestFormItem'
import FormSection from '@/common/components/form/FormSection'
import { projectEndpoint } from '@/core/helpers'
import FeatureToggle from '@/common/components/form/FeatureToggle.vue'

export default {
  name: 'LoyaltySettingsPage',

  components: {
    FeatureToggle,
    RestFormPage,
    RestFormItem,
    FormSection
  },

  data() {
    return {
      model: {}
    }
  },

  computed: {
    pageTitle() {
      return (
        this.$store.getters.embeddedTitle || this.$t(this.$route.meta.title)
      )
    },

    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: ``,
        params: {
          fields: 'loyalty'
        },
        handler: data => {
          this.model = data
        }
      })
    },

    saveEndpoint() {
      return projectEndpoint({
        method: 'post',
        url: `loyalty/provision`,
        params: {
          data: this.model
        }
      })
    },

    readonly() {
      return !this.$isRole('admin')
    }
  },
  methods: {
    handleError() {
      this.model.loyalty = 0
    },
    afterSave(res, loading) {
      this.$store.dispatch('reloadProjectConfig').then(loading())
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/settings/pages/LoyaltySettingsPage.vue